import React, { useState, useEffect } from 'react';
import Menu from '../Menu'
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import '../App.css'


const MyShares = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editRecord, setEditRecord] = useState(null);
    const [mysymb, setMysymb] = useState(""); // state to store input value

    const [isLoading, setIsLoading] = useState(false);
    const mytoken = sessionStorage.getItem('google_token');
    const { platform } = useParams();
    const navigate = useNavigate();
    const [filterValue, setFilterValue] = useState(""); // State to hold filter input
    const [filterKey, setFilterKey] = useState(""); // Key to filter by (default:
    const [sum, setSum] = useState(0);
    const [sumInv, setSumInv] = useState(0);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const filteredData = data.filter((item) => {
        if (!filterValue) return true; // If no filter, show all data
        const itemValue = item[filterKey]?.toString().toLowerCase(); // Convert item value to string for comparison
        return itemValue === filterValue.toLowerCase();
    });

    // Sort the filtered data based on sortConfig
    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;

        // Handle date sorting for last_update_day
        if (sortConfig.key === 'last_update_day') {
            const aDate = new Date(a[sortConfig.key] || 0);
            const bDate = new Date(b[sortConfig.key] || 0);
            if (sortConfig.direction === 'asc') {
                return aDate - bDate;
            } else {
                return bDate - aDate;
            }
        }

        // Handle numeric sorting for other columns
        const aValue = parseFloat(a[sortConfig.key]) || 0;
        const bValue = parseFloat(b[sortConfig.key]) || 0;

        if (sortConfig.direction === 'asc') {
            return aValue - bValue;
        } else {
            return bValue - aValue;
        }
    });

    // Handle column header click for sorting
    const handleSort = (key) => {
        setSortConfig((prevConfig) => ({
            key,
            direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    // Get CSS class for sortable column header
    const getSortClass = (key) => {
        let className = 'sortable';
        if (sortConfig.key === key) {
            className += ' ' + sortConfig.direction;
        }
        return className;
    };

    const [formAdd, setFormAdd] = useState({
        symb: '',
        platform: '',
        nrunits: '',
        valnow: '',
        valinvact: '',
        valc: '',
        currency: '',
        symb_platform: '',
        typeshare: '',
        details: ''

    });


    useEffect(() => {

        console.log(`Parameter changed! Now showing item with ID: ${platform}`);

        // Replace with your API endpoint



        var apiUrl = '';
        if (typeof platform !== "undefined") {
            if (platform === "ALL"){
                apiUrl = 'https://app64.heliohost.us/api/getMyShares.php';
                
            }
            else
                {
                    if (platform.startsWith("symbol-")){

                        apiUrl = 'https://app64.heliohost.us/api/getMyShares.php?symbol=' + platform.substring(7).toUpperCase();    
                    }else 
                    apiUrl = 'https://app64.heliohost.us/api/getMyShares.php?platform=' + platform;
                }
        }
        //const apiUrl = 'http://localhost/api/getShareAlarms.php';

        if(apiUrl !== ""){

        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "AuthCode": mytoken
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
                if (typeof platform !== "undefined") {
                    if (platform !== "ALL" && (!platform.startsWith("symbol-") )) {
                    setFilterValue(platform);
                    setFilterKey("platform");
                    }

                }

                const totalSum = data.reduce((sum, item) => sum + item.nrunits * item.valnow, 0);
                const totalInv = data.reduce((sum, item) => sum + item.nrunits * item.valinvact, 0);
                setSum(totalSum.toFixed(2));
                setSumInv(totalInv.toFixed(2));
                console.log("Total sum :" + totalSum);
                console.log("Total sum Inv :" + totalInv);

            })
            .catch((error) => {
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
            });
        }else {
            setData([]);
            setLoading(false);
            setFilterValue("");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array means this runs once on component mount

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    const mysymbChange = (event) => {
         setMysymb(event.target.value); // update state with input's value
    };



    const handleEditClick = (record) => {
        setEditRecord(record); // Set the record to be edited
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditRecord({ ...editRecord, [name]: value });
    };

    const handleInputChangeAdd = (e) => {
        const { name, value } = e.target;
        setFormAdd({ ...formAdd, [name]: value });
    };


    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;

        if (selectedValue) {
            navigate(`/myshares/${selectedValue}`);
            window.location.reload();
        }

    };

      const searchShares = (event) => {
        
        
        
        if (mysymb) {
            navigate(`/myshares/symbol-${mysymb}`);
            window.location.reload();
        }

    };


    

    const handleSave = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Send PUT request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyShare.php?id=${editRecord.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                },
                body: JSON.stringify(editRecord),
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAdd = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Send PUT request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyShare.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                },
                body: JSON.stringify(formAdd),
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const calculateShares = async (myplatform) => {
        try {
            // Send PUT request to update the record
            setIsLoading(true); // Show spinner

            const response = await fetch(`https://app64.heliohost.us/api/updateValNowShare.php?platform=${myplatform}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                }
                
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }else{
                //alert('ok update');
                window.location.reload();

            }
            
            await response.json();

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div>
            <Menu />
            <h1 className="page-title">My Shares</h1>

            {isLoading ? <div className="spinner"></div> : <pre></pre>}
            <select name="platformsel" id="platform-select" onChange={handleSelectChange}>
                <option value="">--Select--</option>
                <option value="ALL">ALL</option>
                <option value="bttrade">bttrade</option>
                <option value="etoro">etoro</option>
                <option value="goldring">goldring</option>
                <option value="IBKR">IBKR</option>
                <option value="trading212">trading212</option>
                <option value="XTBEUR">XTBEUR</option>
                <option value="XTBUSD">XTBUSD</option>

            </select>

            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Symbol</th>
                            <th>Platform</th>
                            <th>Units</th>
                            <th>Val Inv</th>
                            <th>Val Now</th>
                            <th>Curr</th>
                            <th onClick={() => handleSort('valtnow')} className={getSortClass('valtnow')}>Total Now</th>
                            <th onClick={() => handleSort('valtinv')} className={getSortClass('valtinv')}>Total Inv</th>
                            <th onClick={() => handleSort('procent')} className={getSortClass('procent')}>%</th>
                            <th>Symb Platf</th>
                            <th>Type</th>
                            <th>Details</th>
                            <th onClick={() => handleSort('last_update_day')} className={getSortClass('last_update_day')}>Updated</th>
                            <th>Active</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.symb}</td>
                                <td>{item.platform}</td>
                                <td>{item.nrunits}</td>
                                <td>{item.valinvact}</td>
                                <td>{item.valnow}</td>
                                <td>{item.currency}</td>
                                <td>{item.valtnow}</td>
                                <td>{item.valtinv}</td>
                                <td>{item.procent}</td>
                                <td>{item.symb_platform}</td>
                                <td>{item.typeshare}</td>
                                <td>{item.details}</td>
                                <td>{item.last_update_day}</td>
                                <td>{item.isactive}</td>
                                <td><button className="btn-edit" onClick={() => handleEditClick(item)}>Edit</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div>
                <b>Total {sum}  Inverstit {sumInv} Procent {(((sum/sumInv)-1)*100).toFixed(2)}</b>
                <td><br></br><button onClick={() => calculateShares(platform)}>Update VALNOW shares</button></td>
                <td><br></br><input type="text" value={mysymb} onChange={mysymbChange}></input><button onClick={() => searchShares(platform)}>Search Share</button></td>
            </div>

            {editRecord && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setEditRecord(null)}>
                    <div className="modal-content">
                        <h2>
                            Edit Record
                            <button className="btn-close" onClick={() => setEditRecord(null)}>×</button>
                        </h2>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSave();
                            }}
                        >
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Symbol</label>
                                    <input
                                        type="text"
                                        name="symb"
                                        value={editRecord.symb}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Platform</label>
                                    <input
                                        type="text"
                                        name="platform"
                                        value={editRecord.platform}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Units</label>
                                    <input
                                        type="text"
                                        name="nrunits"
                                        value={editRecord.nrunits}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Currency</label>
                                    <select
                                        name="currency"
                                        value={editRecord.currency}
                                        onChange={handleInputChange}
                                    >
                                        <option value="USD">USD</option>
                                        <option value="EUR">EUR</option>
                                        <option value="RON">RON</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Initial Value</label>
                                    <input
                                        type="text"
                                        name="valinvact"
                                        value={editRecord.valinvact}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Value Now</label>
                                    <input
                                        type="text"
                                        name="valnow"
                                        value={editRecord.valnow}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Symb Platform</label>
                                    <input
                                        type="text"
                                        name="symb_platform"
                                        value={editRecord.symb_platform}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Type Share</label>
                                    <input
                                        type="text"
                                        name="typeshare"
                                        value={editRecord.typeshare}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Details</label>
                                    <input
                                        type="text"
                                        name="details"
                                        value={editRecord.details}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Active</label>
                                    <input
                                        type="text"
                                        name="isactive"
                                        value={editRecord.isactive}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="button-group">
                                <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                    {isLoading ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => setEditRecord(null)}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                        {error && <p className="error-message">{error}</p>}
                    </div>
                </div>
            )}


            <div className="form-card">
                <h2>Add Record</h2>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleAdd();
                    }}
                >
                    <div className="form-row">
                        <div className="form-group">
                            <label>Symbol</label>
                            <input
                                type="text"
                                name="symb"
                                value={formAdd.symb}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Platform</label>
                            <select
                                name="platform"
                                value={formAdd.platform}
                                onChange={handleInputChangeAdd}
                            >
                                <option value="-">-</option>
                                <option value="bttrade">bttrade</option>
                                <option value="etoro">etoro</option>
                                <option value="goldring">goldring</option>
                                <option value="IBKR">IBKR</option>
                                <option value="trading212">trading212</option>
                                <option value="XTBEUR">XTBEUR</option>
                                <option value="XTBUSD">XTBUSD</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Units</label>
                            <input
                                type="text"
                                name="nrunits"
                                value={formAdd.nrunits}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Currency</label>
                            <select
                                name="currency"
                                value={formAdd.currency}
                                onChange={handleInputChangeAdd}
                            >
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                                <option value="RON">RON</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Initial Value</label>
                            <input
                                type="text"
                                name="valinvact"
                                value={formAdd.valinvact}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Value Now</label>
                            <input
                                type="text"
                                name="valnow"
                                value={formAdd.valnow}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Symb Platform</label>
                            <input
                                type="text"
                                name="symb_platform"
                                value={formAdd.symb_platform}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Type Share</label>
                            <input
                                type="text"
                                name="typeshare"
                                value={formAdd.typeshare}
                                onChange={handleInputChangeAdd}
                            />
                        </div>
                    </div>

                    <div>
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? "Adding..." : "Add"}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => setEditRecord(null)}>
                            Cancel
                        </button>
                    </div>
                </form>
                {error && <p className="error-message">{error}</p>}
            </div>


        </div>
    );
}

export default MyShares